import { z } from "zod";

export const PhoneSchema = z.object({
  country_code: z.number().default(1),
  area_code: z.number(),
  phone: z.number(),
});
